import { List } from 'immutable';
import { CategoryFactory } from '@/domain/categories/adapters';
import { CATEGORY_SYSTEM_TYPE_FIELD, CATEGORY_SYSTEM_TYPES } from '@/domain/categories/constants';

import * as ACL from '@/domain/restriction';

// transforms flat list to nested list
export const createTreeFromNestedSet = (arr) =>
  arr
    .sort((a, b) => a.order - b.order || a.left - b.left)
    .reduce(
      (tree, n) => {
        let curr = null;
        let nextIndex = null;
        let next = tree;
        const updatePath = ['children'];
        const parentList = [];

        while (next) {
          curr = next;
          next = curr.children.find((c) => c.left < n.left && c.right > n.right);
          if (next) {
            nextIndex = curr.children.findIndex((c) => c.left < n.left && c.right > n.right);
            updatePath.push(nextIndex, 'children');
            if (next.id !== null && next.id !== undefined) {
              parentList.push(next.id);
            }
          }
        }
        // the only affected field we calculate and update for category record
        const updatedRecord = n.set('parentList', List(parentList));
        return tree.updateIn(updatePath, (list) => list.push(updatedRecord));
      },
      CategoryFactory({ children: new List() }),
    ).children;

export const getRootItems = (list) =>
  list.filter((item) => !item.parent_id).sort((a, b) => a.order - b.order || a.left - b.left);

// takes company route category params and returns most nested one
// for 3/4/5 route it should return 5,
// for 3/4 it should return 4
// for 3 it should return 3
// eslint-disable-next-line max-len
/** @param {{ category1?: string; category2?: string; category3?: string }} params */
export const getNestedCategory = ({ category1, category2, category3 }) => category3 || category2 || category1;

export const getFirstCategory = (list) =>
  list
    .filter((item) => !item.parent_id)
    .sort((a, b) => a.order - b.order || a.left - b.left)
    .first({});

export const getSystemType = (category) => category.get(CATEGORY_SYSTEM_TYPE_FIELD);

export const isSystemType = (category, type) => getSystemType(category) === type;

export const findCatBySystemType = (categories, type) => categories.find((cat) => isSystemType(cat, type));

export const findCatById = (categories, id) => categories.find((cat) => String(cat.id) === String(id));

export const isCategoryAll = (category) => (category ? isSystemType(category, CATEGORY_SYSTEM_TYPES.all) : false);

export const isTrashCategory = (categories, id) => {
  const category = findCatById(categories, id);
  return category ? isSystemType(category, CATEGORY_SYSTEM_TYPES.trash) : false;
};

export const isTrashCategoryById = (category) =>
  category ? isSystemType(category, CATEGORY_SYSTEM_TYPES.trash) : false;

export const getCategoryInbox = (categories) => findCatBySystemType(categories, CATEGORY_SYSTEM_TYPES.inbox);

export const isToApproveCategory = (category) =>
  category ? isSystemType(category, CATEGORY_SYSTEM_TYPES.to_approve) : false;

export const isInboxCategory = (category) =>
  category ? isSystemType(category, CATEGORY_SYSTEM_TYPES.inbox) : false;

export const isPublishFailedCategory = (category) =>
  category ? isSystemType(category, CATEGORY_SYSTEM_TYPES.publish_failed) : false;

export const getCategoryAll = (categories) => findCatBySystemType(categories, CATEGORY_SYSTEM_TYPES.all);

export const getMovableCategories = (currentCategoryId, rootCategories) =>
  rootCategories.filter((cat) => cat.documentMovable && String(cat.id) !== String(currentCategoryId));

export const isMovableCategories = (currentCategoryId, rootCategories) =>
  getMovableCategories(currentCategoryId, rootCategories).size;

export const isAllowMoveToCategories = ({ isGranted, rootCategories, currentRootCategoryId }) =>
  isGranted(ACL.IS_ACCOUNT) && isMovableCategories(currentRootCategoryId, rootCategories);
